import React from "react";
import Page from "../../components/Common/Page";
import PagesHeader from "../../components/Common/PagesHeader";

const AboutUs = () => {
  return (
    <Page title="About Us">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <PagesHeader
            pageTitle="About Us"
            homePageUrl="/"
            homePageText="Dashboard"
            activePageText="About Us"
          />

          <div className="row">
            <div className="col-md-12">
              <div className="card" style={{ borderRadius: "10px", border: "1px solid #d0d7de", boxShadow: "none" }}>
                <div className="card-body">
                  <h4 className="card-title" style={{ color: "#1C75BC", fontWeight: "700", marginBottom: "15px" }}>
                    Choice Dekho Admin Portal
                  </h4>
                  <p style={{ fontSize: "15px", color: "#4f5e64", lineHeight: "1.6" }}>
                    Choice Dekho is an enterprise-grade administration hub designed to aggregate, harmonize, and enrich professional courses from multiple source platforms. The system provides powerful workflows for skill taxonomy management, automated merchant importing, category mapping, and AI-driven content harmonization.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="card" style={{ borderRadius: "10px", border: "1px solid #d0d7de", height: "100%", boxShadow: "none" }}>
                <div className="card-body">
                  <h5 className="card-title" style={{ fontWeight: "600", color: "#333", marginBottom: "15px" }}>System Overview</h5>
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td style={{ width: "150px", fontWeight: "600", padding: "8px 0" }}>App Version</td>
                        <td style={{ padding: "8px 0", color: "#666" }}>v1.2.0-stable</td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "600", padding: "8px 0" }}>Theme Version</td>
                        <td style={{ padding: "8px 0", color: "#666" }}>2.4.0 (Ayu Light / Premium Off-White)</td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "600", padding: "8px 0" }}>API Status</td>
                        <td style={{ padding: "8px 0" }}>
                          <span className="badge bg-success" style={{ padding: "5px 10px", fontSize: "11px", fontWeight: "600" }}>Operational</span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "600", padding: "8px 0" }}>Environment</td>
                        <td style={{ padding: "8px 0", color: "#666" }}>Production-Admin</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card" style={{ borderRadius: "10px", border: "1px solid #d0d7de", height: "100%", boxShadow: "none" }}>
                <div className="card-body">
                  <h5 className="card-title" style={{ fontWeight: "600", color: "#333", marginBottom: "15px" }}>Core Functions</h5>
                  <ul className="list-unstyled" style={{ color: "#4f5e64", lineHeight: "2.2" }}>
                    <li>
                      <i className="la la-check-circle" style={{ color: "#28a745", marginRight: "8px", fontSize: "16px" }} />
                      Multi-merchant Course Aggregation
                    </li>
                    <li>
                      <i className="la la-check-circle" style={{ color: "#28a745", marginRight: "8px", fontSize: "16px" }} />
                      Granular Affiliation & Category Mapping
                    </li>
                    <li>
                      <i className="la la-check-circle" style={{ color: "#28a745", marginRight: "8px", fontSize: "16px" }} />
                      AI-assisted Bulk Harmonization Jobs
                    </li>
                    <li>
                      <i className="la la-check-circle" style={{ color: "#28a745", marginRight: "8px", fontSize: "16px" }} />
                      Platform Status & Pipeline Oversight
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default AboutUs;
